// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2L1WV","title":"Header_title__1LSf9","side":"Header_side__eod7P"};